// extracted by mini-css-extract-plugin
module.exports = {"cookiePopup":"styles_cookiePopup__bmoM7","card":"styles_card__2Bp9N","content":"styles_content__kIy5X","actions":"styles_actions__LX87F"};